import React, { forwardRef } from "react";
import { AutoSizer, Table, Column } from "react-virtualized";
import TicketTableHeader from "./ticket_table_header";
import styled from "styled-components";

const TicketTable = forwardRef((props, ref) => {
  console.log("ticket table", props);
  const {
    loaded,
    sortDirection,
    tickets,
    noRowsRenderer,
    rowRenderer,
    tableScroll,
    project,
    column,
    sortTickets,
  } = props;

  function headerRowRenderer() {
    return (
      <TicketTableHeader
        project={project}
        props={props}
        column={column}
        direction={sortDirection}
        sortTickets={sortTickets}
      />
    );
  }

  if (!loaded) {
    return (
      <LoaderContainer>
        <div id="test-step-bugs-loader" />
      </LoaderContainer>
    );
  }

  return (
    <FlexContainer>
      <AutoSizer>
        {({ width, height }) => (
          <Table
            ref={ref}
            id="ticket-container-table"
            width={width}
            height={height}
            headerHeight={25}
            onScroll={(height) => tableScroll(height)}
            className="striped highlight"
            rowHeight={32}
            sortBy={column}
            sortDirection={sortDirection}
            noRowsRenderer={noRowsRenderer}
            headerRowRenderer={headerRowRenderer}
            overscanRowCount={2}
            rowRenderer={rowRenderer}
            rowCount={tickets.length}
            rowGetter={({ index }) => tickets[index]}
          >
            <Column label="Id" dataKey="id" width={60} />
            <Column
              headerClassName="flexBasisAuto"
              width={70}
              label="Priority"
              dataKey="ticket_priority_id"
            />
            <Column width={360} flexGrow={1} label="Title" dataKey="title" />
            <Column width={60} label="Status" dataKey="ticket_status_id" />
            <Column width={100} label="Assignee" dataKey="assignee_id" />
            <Column width={100} label="Reporter" dataKey="tester_id" />
            <Column width={100} label="WCAG" dataKey="a11y_id" />
            <Column width={100} label="Created" dataKey="created_at" />
          </Table>
        )}
      </AutoSizer>
    </FlexContainer>
  );
});

export default TicketTable;

export const LoaderContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const FlexContainer = styled.div`
  display: flex;
  flex: 1;
`;

export const StyledTable = styled.div`
  // you can optionally style react-virtualized Table here if needed
`;
